import Vue from 'vue';
import type { Store } from 'vuex';
import Vuex from 'vuex';
import { getResultModule } from './result';
import { getPayDelayModule } from './paydelaycashier';
import { getPayDeferModule } from './paydefercashier';
import { getPayDelaySignModule } from './paydelaysign';
import { getPaymentModule } from './payment';
import type { DeferRootState } from './constants';

function _createInstance() {
  return new Vuex.Store<DeferRootState>({
    // 不要在发布环境下启用严格模式！严格模式会深度监测状态树来检测不合规的状态变更——请确保在发布环境下关闭严格模式，以避免性能损失。
    strict: process.env.NODE_ENV !== 'prod' && process.env.NODE_ENV !== 'production',
    plugins: undefined,
    modules: {
      paydelaycashier: getPayDelayModule(),
      paydefercashier: getPayDeferModule(),
      paydelaysign: getPayDelaySignModule(),
      result: getResultModule(),
      payment: getPaymentModule(),
    },
  });
}
Vue.use(Vuex);

const store: Store<DeferRootState> = _createInstance();
export function storeInstance() {
  return store;
}
